export const displayAlert = {
  data () {
    return {
      alert: false,
      alertType: 'warning',
      alertMessage: '',
      errors: [],
      messages: [],
      successes: [],
      timeout: -1
    }
  },
  watch: {
    errors: {
      handler (newValue) {
        if (newValue) {
          if (this.errors.length >= 1) {
            this.emitAlert(true, 'warning', 'Please correct the following errors: ', this.errors, this.timeout)
          }
        }
      }
    },
    successes: {
      handler (newValue) {
        if (newValue) {
          if (this.successes.length >= 1) {
            this.emitAlert(true, 'success', 'Success: ', this.successes, this.timeout)
          }
        }
      }
    }
  },
  methods: {
    emitAlert (showAlert, alertType, alertMessage, messages, timeout) {
      const payload = {
        alert: showAlert,
        alertType: alertType,
        alertMessage: alertMessage,
        messages: messages,
        timeout: timeout
      }
      this.$root.$emit('alertdialog', payload)
    },
    resetAlert () {
      this.errors.length = 0
      this.successes.length = 0
      const payload = {
        alert: false,
        alertType: 'success',
        alertMessage: '',
        messages: []
      }
      this.$root.$emit('alertdialog', payload)
    },
    handleRejected (rejected) {
      const errs = rejected.map(e => {
        // can't use optional chaining until babel is updated
        if (e.reason) {
          const { response } = e.reason
          if (response && response.data) {
            return response.data.message || JSON.stringify(response.data)
          }
          return e.reason.message
        }
        return e
      })
      const message = `The following errors have occurred: ${errs.join(', ')}`
      this.emitAlert(true, 'warning', message)
    },
    handleError (err) {
      if (Array.isArray(err)) {
        return this.handleRejected(err)
      }
      console.error(err)
      let message = err.message
      if (err.response && err.response.data) {
        message = err.response.data.message || JSON.stringify(err.response.data)
      }

      if (message.toLowerCase().includes("network error")) {
        const regex = /network error.*/i // Remove 'Network Error' from message. Replace with 'Please refresh the page'
        message = message.replace(regex, "Please refresh the page.")
        console.error("Unable to connect to backend. Page refresh may be needed.")
      }
      this.emitAlert(true, 'warning', message)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/alert.js